import React, { FC, useEffect } from 'react';
import { Slide as SlideType } from '@/eventConfig/types.ts';
import { useNavigation } from '@/navigation/NavigationContex.ts';
import { RenderField } from '@/form/fields/RenderField.tsx';
import { ConfigSlideId } from '@/eventConfig/types.ts';
import { useForm } from '@/form/useForm.ts';

interface ConfirmDataEntryCheckboxProps {
  slide: SlideType;
  slideIdsToValidate: ConfigSlideId[];
}

export const ConfirmDataEntryCheckbox: FC<ConfirmDataEntryCheckboxProps> = ({ slide, slideIdsToValidate }) => {
  const { currentSlide } = useNavigation();
  const { validateSlide, getFieldStatus, onChange } = useForm();

  const allValid = slideIdsToValidate.every((id) => validateSlide(id));

  const field = slide.fields.find(({ name }) => name === 'dataEntryConfirmed');

  useEffect(() => {
    if (!field) return;

    if (!allValid) {
      const fieldStatus = getFieldStatus(field.name);
      if (fieldStatus && fieldStatus.isValid) {
        onChange(field.name, {
          ...fieldStatus,
          isValid: false,
        });
      }
    }
  }, [allValid, field, getFieldStatus, onChange]);

  if (!field || !allValid) return null;

  return <RenderField slideId={currentSlide!.id} field={field} />;
};
